module.exports = __webpack_public_path__ + "img/mang4.485b0d9c.jpg";